/**
 * The SSE text-stream wire contract, shared by producer and consumer (plan
 * `plans/2026-09-23-001-contact-actions-play-deeplink-and-hardening-plan.md`
 * U3, decision D11).
 *
 * Producer: `src/api/flow/flow-contacts-intel.ts` types every `send()`
 * payload as `SseTextFrame`, so a frame shape can't drift server-side
 * without a type error.
 * Consumer: `web/app-home/src/lib/sse-text-stream.ts` `safeParse`s each
 * decoded frame before touching a callback — a `delta` whose `text` arrived
 * as an object must never be string-concatenated into the summary as
 * `[object Object]`.
 *
 * The schema is canonical for the shape; the type is derived via `z.infer`
 * (never hand-written alongside it — `terra/no-parallel-schema-and-type`).
 */
import { z } from 'zod';

export const SseTextFrameSchema = z.discriminatedUnion('type', [
  z.object({ type: z.literal('delta'), text: z.string() }),
  z.object({ type: z.literal('done') }),
  z.object({ type: z.literal('error'), message: z.string().optional() }),
]);

export type SseTextFrame = z.infer<typeof SseTextFrameSchema>;
